import React from 'react';
import { Box, Button, Paper, Typography } from '@mui/material';
import { useRouteError } from 'react-router-dom';

export default function ErrorPage() {
  const error = useRouteError();
  console.warn(`ErrorPage:${JSON.stringify(error)}`);

  const isChunkLoadError = error?.name === 'ChunkLoadError' || error?.message?.includes('Loading chunk');

  const handleRetry = () => {
    window.location.reload();
  };

  if (isChunkLoadError) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', mt: 5 }}>
        <Paper
          id='error-page'
          elevation={3}
          sx={{ borderRadius: '12px', backgroundColor: (theme) => theme.palette.background.light1, p: 3, m: 4, display: 'inline-block' }}
        >
          <Typography variant='h3'>Sorry for the inconvenience</Typography>
          <Typography variant='h3'>The application has changed</Typography>
          <Typography variant='h3'>Please try reloading the page.</Typography>
          <Button fullWidth variant='contained' onClick={handleRetry} sx={{ px: 4, mt: 3 }}>
            Reload
          </Button>
        </Paper>
      </Box>
    );
  }

  return (
    <div id='error-page'>
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <p>
        <i>{error?.statusText || error?.message}</i>
      </p>
    </div>
  );
}
